import categoriesActions from '../actions/categoriesActions';

const categoriesReducer = (state = [], action) => {
  switch (action.type) {
    case categoriesActions.constants.set:
      return action.payload;
    default:
      return state;
  }
};

export default categoriesReducer;
